export const weeklyCalendar_Style = {
  dateRangeSx: {
    display: 'flex',
    justifyContent: 'center',
  },
  iconSx: {
    // color: '#fff'
  },
};
